import {Injectable}      from '@angular/core'
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ConditionFactorService {
  // Observable item source
  private itemSource = new BehaviorSubject<boolean>(false);
  private cancelSource = new BehaviorSubject<boolean>(false);

  // Observable navItem stream
  item$ = this.itemSource.asObservable();
  cancel$ = this.cancelSource.asObservable();

  // service command
  update(updateUI: boolean) {
    this.itemSource.next(updateUI);
  }

  cancel(cancel: boolean) {
    this.cancelSource.next(cancel);
  }
}
